(() => {
	let slideshowSwipers = []; // Store all slideshow Swiper instances

	const initSliders = () => {
		const slideshows = document.querySelectorAll(".home-poster-wrapper");
  		slideshows.forEach((slideshow) => {
  			const autoplay =
  				slideshow.getAttribute("data-autoplay") === "true" ? true : false;
  			const stopAutoplay =
  				slideshow.getAttribute("data-stop-autoplay") === "true" ? false : true;
  			const slideshowSwiper = new Swiper(slideshow, {
                autoplay: autoplay,
                loop:true,
                pagination: {
                  el: ".slideshow__control-wrapper",
                  clickable :true,
                },
                 navigation: {
                  nextEl: ".home-poster-wrapper .slider-button--next",
                  prevEl: ".home-poster-wrapper .slider-button--prev",
                }
    		});
  	})
    }
	initSliders();

	document.addEventListener("shopify:section:load", function () {
		initSliders();
	});
})();
